/**
 * @fileoverview POST handler for the "/:app_group_id/figma/images" endpoint
 */
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { postAppGroupIdFigmaImagesCacheKeys } from "./constants";
import type {
  PostAppGroupIdFigmaImagesProps,
  PostAppGroupIdFigmaImagesResult,
  PostAppGroupIdFigmaImagesResultErrors,
} from "./types";

export const postAppGroupIdFigmaImages = reactQueryMutationAdapter(
  postAppGroupIdFigmaImagesCacheKeys,
  createMutationFetcherFunctionWithShadowError<PostAppGroupIdFigmaImagesResultErrors>()(
    (props: PostAppGroupIdFigmaImagesProps): Promise<PostAppGroupIdFigmaImagesResult> => {
      return fetch(
        `/${props.appGroupId}/figma/images`,
        "POST",
        {
          file_key: props.fileKey,
          ids: props.ids,
          ...(props.scale !== undefined && { scale: props.scale }),
          ...(props.format !== undefined && { format: props.format }),
          ...(props.svgOutlineText !== undefined && { svg_outline_text: props.svgOutlineText }),
          ...(props.svgIncludeId !== undefined && { svg_include_id: props.svgIncludeId }),
          ...(props.svgIncludeNodeId !== undefined && { svg_include_node_id: props.svgIncludeNodeId }),
          ...(props.svgSimplifyStroke !== undefined && { svg_simplify_stroke: props.svgSimplifyStroke }),
          ...(props.contentsOnly !== undefined && { contents_only: props.contentsOnly }),
          ...(props.useAbsoluteBounds !== undefined && { use_absolute_bounds: props.useAbsoluteBounds }),
        },
        undefined,
        { propagateFetchRequestError: false }
      );
    }
  )
);
